import secureRequest from "@toothfairy/shared-api/secureAPI";
import envConfig from "../../../envConfig";
import client from "@toothfairy/shared-api/src/Common/client";

const processAudio = async ({ token, data }) => {
  let headers;
  if (token) headers = { "x-api-key": token };
  let url = `${envConfig.REACT_APP_REST_ENDPOINT}/media/audio`;
  const body = {
    ...data,
    diarisation: data?.diarisation || false,
  };

  return secureRequest(client, "POST", url, null, body, false, headers);
};

const processVideo = async ({ token, data }) => {
  let headers;
  if (token) headers = { "x-api-key": token };
  let url = `${envConfig.REACT_APP_REST_ENDPOINT}/media/video`;
  const body = data;

  return secureRequest(client, "POST", url, null, body, false, headers);
};

const generateAudio = async ({ token, data }) => {
  let headers;
  if (token) headers = { "x-api-key": token };
  let url = `${envConfig.REACT_APP_REST_ENDPOINT}/media/audio_generation`;
  const body = data;

  return secureRequest(client, "POST", url, null, body, false, headers);
};

const cloneVoice = async ({
  token,
  workspaceid,
  clip,
  name,
  description,
  language,
}) => {
  const myHeaders = new Headers();
  if (token) myHeaders.append("x-api-key", token);
  const formdata = new FormData();
  formdata.append("clip", clip, clip?.name || "clip.wav");
  formdata.append("workspaceid", workspaceid);
  formdata.append("name", name);
  if (description) formdata.append("description", description);
  if (language) formdata.append("language", language);

  return fetch(`${envConfig.REACT_APP_REST_ENDPOINT}/media/voices/clone`, {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  });
};

const listClonedVoices = async ({ token, workspaceid }) => {
  let headers;
  if (token) headers = { "x-api-key": token };
  let url = `${envConfig.REACT_APP_REST_ENDPOINT}/media/voices?workspaceid=${encodeURIComponent(workspaceid)}`;

  return secureRequest(client, "GET", url, null, null, false, headers);
};

export default {
  processAudio,
  processVideo,
  generateAudio,
  cloneVoice,
  listClonedVoices,
};
